module.exports = __webpack_public_path__ + "img/ssyx_18.3775f7cc.jpg";